import { render, staticRenderFns } from "./valuable-concepts-modal-grid.vue?vue&type=template&id=6be8deea&scoped=true&"
import script from "./valuable-concepts-modal-grid.ts?vue&type=script&lang=ts&"
export * from "./valuable-concepts-modal-grid.ts?vue&type=script&lang=ts&"
import style0 from "./valuable-concepts-modal-grid.scss?vue&type=style&index=0&id=6be8deea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be8deea",
  null
  
)

export default component.exports